import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=08980a65&scoped=true&"
import script from "./Analysis.vue?vue&type=script&lang=js&"
export * from "./Analysis.vue?vue&type=script&lang=js&"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=08980a65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08980a65",
  null
  
)

export default component.exports